var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "d-flex justify-start flex-column" },
    [
      _c(
        "v-sheet",
        { staticClass: "pl-1 d-inline-block text-truncate transparent" },
        [
          _vm.showLabel
            ? _c("span", { class: _vm.labelClass }, [
                _vm._v(" " + _vm._s(_vm.label) + " "),
              ])
            : _vm._e(),
        ]
      ),
      _c(
        "v-menu",
        {
          ref: "colormenu",
          staticClass: "rounded-t-lg",
          attrs: {
            color: "white",
            elevation: 4,
            "offset-y": "",
            "disable-keys": "",
            transition: "slide-y-transition",
            "close-on-content-click": false,
            "close-on-click": true,
          },
          scopedSlots: _vm._u([
            {
              key: "activator",
              fn: function (ref) {
                var attrs = ref.attrs
                var on = ref.on
                var value = ref.value
                return [
                  _c(
                    "v-select",
                    _vm._g(
                      _vm._b(
                        {
                          ref: "select",
                          attrs: {
                            items: _vm.items,
                            "item-text": _vm.itemText,
                            "item-value": _vm.itemValue,
                            dense: _vm.dense,
                            height: _vm.height ? _vm.height : undefined,
                            "append-icon": !_vm.showMenu
                              ? _vm.appendIcon
                              : _vm.appendExpandIcon,
                            readonly: true,
                            filled: _vm.filled,
                            rules: _vm.readonly ? [] : _vm.rules,
                            "single-line": _vm.singleLine,
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "no-data",
                                fn: function () {
                                  return [_c("noContent")]
                                },
                                proxy: true,
                              },
                              {
                                key: "selection",
                                fn: function (ref) {
                                  var item = ref.item
                                  var index = ref.index
                                  return [
                                    _c("v-chip", {
                                      style: {
                                        minWidth: "70px",
                                        maxWidth: "120px",
                                      },
                                      attrs: {
                                        small: "",
                                        label: "",
                                        color: _vm.selectColor,
                                      },
                                    }),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                          model: {
                            value: _vm.selectColor,
                            callback: function ($$v) {
                              _vm.selectColor = $$v
                            },
                            expression: "selectColor",
                          },
                        },
                        "v-select",
                        attrs,
                        false
                      ),
                      _vm.readonly ? null : on
                    )
                  ),
                  _c(
                    "v-sheet",
                    _vm._g(
                      _vm._b(
                        {
                          staticStyle: {
                            "margin-bottom": "-40px",
                            "z-index": "2",
                          },
                          attrs: { height: "40", color: "transparent" },
                          on: {
                            click: function ($event) {
                              !_vm.readonly
                                ? function () {
                                    _vm.$refs["select"].focus()
                                    _vm.showMenu = true
                                  }
                                : _vm.$refs["select"].focus()
                            },
                          },
                        },
                        "v-sheet",
                        attrs,
                        false
                      ),
                      !_vm.readonly ? on : null
                    )
                  ),
                ]
              },
            },
          ]),
          model: {
            value: _vm.showMenu,
            callback: function ($$v) {
              _vm.showMenu = $$v
            },
            expression: "showMenu",
          },
        },
        [
          _c(
            "v-container",
            {
              staticClass:
                "\n        white\n        pa-4\n        rounded-b-lg\n        scroll_content_y\n        d-flex\n        flex-wrap flex-row\n        align-center align-items-center\n        text-center\n        align-self-center\n      ",
              staticStyle: { width: "100%", "max-height": "350px" },
              attrs: { fluid: "", tile: "" },
            },
            _vm._l(_vm.items, function (item, index) {
              return _c(
                "v-sheet",
                {
                  key: "colors--" + index,
                  staticClass: "d-flex align-center px-1 my-1",
                  attrs: { height: "30", width: "20%" },
                },
                [
                  _c("v-hover", {
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (ref) {
                            var hover = ref.hover
                            return [
                              _c(
                                "v-sheet",
                                {
                                  staticClass: "rounded",
                                  attrs: {
                                    color: item.color,
                                    height: "100%",
                                    width: "100%",
                                  },
                                  on: {
                                    click: function ($event) {
                                      _vm.selectColor == item.color
                                        ? null
                                        : (_vm.selectColor = item.color)
                                    },
                                  },
                                },
                                [
                                  hover || _vm.selectColor == item.color
                                    ? _c(
                                        "v-sheet",
                                        {
                                          staticClass:
                                            "rounded d-flex flex-row justify-center align-center",
                                          attrs: {
                                            height: "100%",
                                            width: "100%",
                                            color: "rgba(0,0,0,0)",
                                          },
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "material-icons-round",
                                              class:
                                                _vm.selectColor == item.color
                                                  ? "text--primary"
                                                  : "white--text",
                                            },
                                            [_vm._v("check_circle")]
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      true
                    ),
                  }),
                ],
                1
              )
            }),
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }